// extracted by mini-css-extract-plugin
export var actionButton = "_e1-0";
export var attachmentLine = "_e1-1";
export var fileInput = "_e1-2";
export var fileUploadWrapper = "_e1-4";
export var footer = "_e1-3";
export var modalContent = "_e1-5";
export var paperclip = "_e1-6";
export var quillEditor = "_e1-7";